import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import {
  Table,
  Button,
  Icon,
  DateTime,
  Text,
  TableCell
} from 'components/common/Elements/Elements';
import AdditionalContent from '../AdditionalContent/AdditionalContent';

import { statusColor } from 'utils/common';

import classes from './MaintenanceTable.module.scss';
import { hasAccess, resources, access } from 'utils/permissions';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  idOpenRow,
  handleOpenRow,
  onOpenAdditionalModal,
  indexRow
}) => {
  const hasTenantSensitiveDataReadAccess = hasAccess([
    resources.TENANT_SENSITIVE_DATA,
    access.READ
  ]);
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        const idForOpen = `${indexRow}-${company.maintenanceId}-${company.cloudProvider}-${company.providerRegionName}`;
        return (
          <Fragment key={`${field}-${company._id}}`}>
            {show && field === 'maintenanceId' && (
              <TableCell cellProps={cellProps} isId>
                {company.subData.length > 0 && (
                  <Button
                    className={cn(
                      classes.button,
                      classes.button_wrap,
                      idOpenRow === idForOpen && classes.button_open
                    )}
                    onClick={() => {
                      handleOpenRow(idForOpen);
                    }}
                    aria-label="Open/close"
                  >
                    <Icon
                      size="16px"
                      icon="arrow"
                      className={
                        idOpenRow !== idForOpen
                          ? classes.iconDown
                          : classes.iconUp
                      }
                    />
                    {idOpenRow === idForOpen && (
                      <Icon
                        icon="parentLine"
                        size="73px"
                        className={cn(classes.lineDot)}
                      />
                    )}
                  </Button>
                )}
                {company.subData.length < 1 && (
                  <div className={classes.nullButton} />
                )}
                <Text type="s">{company.maintenanceId}</Text>
              </TableCell>
            )}
            {show && field === 'cloudProvider' && (
              <TableCell cellProps={cellProps}>
                {company.cloudProvider}
              </TableCell>
            )}
            {show && field === 'providerRegionName' && (
              <TableCell cellProps={cellProps}>
                {company.providerRegionName}
              </TableCell>
            )}
            {show && field === 'maintenanceStatus' && (
              <TableCell cellProps={cellProps}>
                <div className={classes.notifWrap}>
                  <div
                    className={classes.marker}
                    style={{
                      backgroundColor: statusColor(
                        company.maintenanceStatus.toLowerCase()
                      )
                    }}
                  />
                  <Text className={classes.notif} weight="m">
                    {company.maintenanceStatus}
                  </Text>
                </div>
              </TableCell>
            )}
            {show && field === 'maintenanceStartTime' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.maintenanceStartTime} time />
              </TableCell>
            )}
            {show && field === 'maintenanceEndTime' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.maintenanceEndTime} time />
              </TableCell>
            )}
            {show && field === 'networkIdsCount' && (
              <TableCell cellProps={cellProps}>
                {!isNaN(company.networkIdsCount) &&
                hasTenantSensitiveDataReadAccess ? (
                  <Button
                    className={classes.appliedTo_button}
                    onClick={() =>
                      onOpenAdditionalModal({
                        content: (
                          <AdditionalContent
                            id={company._id}
                            mode={'networks'}
                          />
                        )
                      })
                    }
                  >
                    {company.networkIdsCount}
                  </Button>
                ) : (
                  company.networkIdsCount
                )}
              </TableCell>
            )}
            {show && field === 'customerIdsCount' && (
              <TableCell cellProps={cellProps}>
                {!isNaN(company.networkIdsCount) &&
                hasTenantSensitiveDataReadAccess ? (
                  <Button
                    className={classes.appliedTo_button}
                    onClick={() =>
                      onOpenAdditionalModal({
                        content: (
                          <AdditionalContent
                            id={company._id}
                            mode={'customers'}
                          />
                        )
                      })
                    }
                  >
                    {company.customerIdsCount}
                  </Button>
                ) : (
                  company.customerIdsCount
                )}
              </TableCell>
            )}
            {show && field === 'gatewayIdsCount' && (
              <TableCell cellProps={cellProps}>
                {!isNaN(company.networkIdsCount) &&
                hasTenantSensitiveDataReadAccess ? (
                  <Button
                    className={classes.appliedTo_button}
                    onClick={() =>
                      onOpenAdditionalModal({
                        content: (
                          <AdditionalContent
                            id={company._id}
                            mode={'gateways'}
                          />
                        )
                      })
                    }
                  >
                    {company.gatewayIdsCount}
                  </Button>
                ) : (
                  company.gatewayIdsCount
                )}
              </TableCell>
            )}
            {show && field === 'messageIdsCount' && (
              <TableCell cellProps={cellProps}>
                {!isNaN(company.messageIdsCount) &&
                hasTenantSensitiveDataReadAccess ? (
                  <Button
                    className={classes.appliedTo_button}
                    onClick={() =>
                      onOpenAdditionalModal({
                        content: (
                          <AdditionalContent
                            id={company._id}
                            mode={'messages'}
                          />
                        )
                      })
                    }
                  >
                    {company.messageIdsCount}
                  </Button>
                ) : (
                  company.messageIdsCount
                )}
              </TableCell>
            )}
            {show && field === 'maintenanceSubject' && (
              <TableCell cellProps={cellProps}>
                {company.maintenanceSubject}
              </TableCell>
            )}
            {show && field === 'alertCreatedAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.alertCreatedAt} time />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  handleCheckCustomer: PropTypes.func,
  isSelectedCustomer: PropTypes.func,
  CheckBox: PropTypes.func,
  handleOpenRow: PropTypes.func.isRequired,
  idOpenRow: PropTypes.string,
  onOpenAdditionalModal: PropTypes.func.isRequired,
  indexRow: PropTypes.number.isRequired
};

export default TableRow;
